export const LOAD_TICKERS = 'decrypt/tickers/LOAD_TICKERS';

export const LOAD_MARKET_INFO = 'decrypt/marketInfo/LOAD_MARKET_INFO';

export const LOAD_DETAILS = 'decrypt/details/LOAD_DETAILS';
export const SET_DETAILS = 'decrypt/details/SET_DETAILS';
export const REMOVE_NAV_BACK = 'decrypt/details/REMOVE_NAV_BACK';
